module.exports = __webpack_public_path__ + "static/img/rotation-chart2.e6166692.jpeg";